import React, { useEffect, useState } from "react";
import { CONSTANTS_STRINGS } from "../../Utils/Constant";

function About() {
  const [selectedFeature, setSelectedFeature] = useState("expertise");

  const feature_data = CONSTANTS_STRINGS.about.features;

  const [count, setCount] = useState(0);
  const target = 20;

  useEffect(() => {
    let start = 0;
    const duration = 2000; // 1 second
    const incrementTime = Math.floor(duration / target); // time per increment

    const counter = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === target) clearInterval(counter);
    }, incrementTime);

    return () => clearInterval(counter); // Cleanup
  }, []);

  return (
    <>
      {/* About Section */}
      <div className="w-full h-auto md:flex justify-center mt-30 gap-10 py-20 px-10 bg-white">
        <div className="md:w-[53%] flex flex-col items-start justify-center p-4">
          <span className="bg-gray-100 text-green-700 text-xs px-2 py-1 rounded">
            {CONSTANTS_STRINGS.about.t1}
          </span>
          <p className="lg:text-5xl text-2xl font-medium mt-5">
            {CONSTANTS_STRINGS.about.t2}
          </p>
          <button className="text-2xl font-semibold bg-gray-900 md:px-10 px-4 md:py-3 py-1 rounded-full text-white mt-15 hover:bg-gray-800 transition-colors">
            {CONSTANTS_STRINGS.about.about_button}
          </button>
        </div>

        <div className="border-r border-gray-300 my-4"></div>
        <div className="md:w-[30%]">
          <p className="lg:text-6xl text-3xl font-medium text-green-700 mt-5">
            {count}+
          </p>
          <p className="text-lg">{CONSTANTS_STRINGS.about.t3}</p>

          <div className="border-t border-gray-300 my-10"></div>

          <div className="w-full md:w-[30%]">
            {/* Buttons with Flexbox for Responsive Layout */}
            <div className="lg:flex  justify-start xl:gap-6 lg:gap-4  pb-4">
              {feature_data.map((feature) => (
                <button
                  key={feature.id}
                  onClick={() => setSelectedFeature(feature.id)}
                  className="relative md:px-2 sm:px-1 px-2 py-2 text-lg    font-medium text-gray-600 transition-all duration-300"
                >
                  {feature.title}

                  {/* Bottom border span */}
                  <span
                    className={`absolute bottom-0 left-0 h-0.5 bg-green-700 transition-all duration-300 ${
                      selectedFeature === feature.id ? "w-full" : "w-0"
                    }`}
                  />
                </button>
              ))}
            </div>

            {/* Description */}
            <p className="mt-6 text-lg xl:w-110 lg:w-80 md:w-60   ">
              {
                feature_data.find((feature) => feature.id === selectedFeature)
                  ?.description
              }
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
